import React from 'react';
import { type RouteObject, redirect } from 'react-router-dom';

const TagPage = React.lazy(() => import('@/pages/tag'));

export const tagRoutes: RouteObject[] = [
  {
    path: 'tag',
    loader: ({ params }) => redirect(`/${params.lang}/explore`),
  },
  {
    path: 'tags',
    loader: ({ params }) => redirect(`/${params.lang}/explore`),
  },
  {
    path: 'tags/:slug',
    element: <TagPage />,
  },
  {
    path: 'tag/:slug',
    element: <TagPage />,
  },
];
